<template>
	<div style="padding: 0 10px">
		<!--    订单信息 start-->
		<!--    订单信息 start-->
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<span>基本信息</span>
			</div>
			<el-descriptions :column="2">
				<el-descriptions-item label="商品SKU">{{
					productDetail.shopProductSku
				}}</el-descriptions-item>
				<el-descriptions-item label="库存总量">{{
					productDetail.checked
				}}</el-descriptions-item>
				<el-descriptions-item label="中文品名">{{
					productDetail.productCategoryName
				}}</el-descriptions-item>
				<el-descriptions-item label="商品链接">
					<a :href="productDetail.productLink" target="_blank">{{
						productDetail.productLink
					}}</a>
					<a
						v-if="productDetail?.productCode"
						style="margin-left: 5px"
						target="_blank"
						:href="`https://s.theckb.com/ja/goods/${productDetail?.productCode}`"
					>
						CKB链接
					</a>
				</el-descriptions-item>
				<el-descriptions-item label="商品图片" span="2">
					<ImgView :src="productDetail.productImg" width="60" height="80" />
				</el-descriptions-item>
				<el-descriptions-item label="商品备注" span="2">{{
					productDetail.remark
				}}</el-descriptions-item>
			</el-descriptions>
		</el-card>
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<span>申报信息</span>
				<el-button
					style="float: right"
					type="primary"
					@click="toModifyCustoms(2)"
					v-if="tableType != 'shipped'"
					>编辑
				</el-button>
				<el-button
					style="float: right; margin: 0 10px"
					type="primary"
					@click="getgoodsFeign"
					>更新申报信息
				</el-button>
			</div>
			<el-descriptions :column="2" labelStyle="width: 90px;margin-left: 10px">
				<el-descriptions-item label="申报品名(英文)">
					<el-input
						maxlength="450"
						v-model="productDetail.productCategoryEnglishName"
					></el-input>
				</el-descriptions-item>
				<el-descriptions-item label="申报品名(中文)">
					<el-input
						maxlength="450"
						v-model="productDetail.productCategoryName"
					></el-input>
				</el-descriptions-item>
				<el-descriptions-item label="编制方式材质(英文)">
					<el-input
						maxlength="450"
						v-model="productDetail.compilationMethodEn"
					></el-input>
				</el-descriptions-item>
				<el-descriptions-item label="编制方式材质(中文)">
					<el-input
						maxlength="450"
						v-model="productDetail.compilationMethod"
					></el-input>
				</el-descriptions-item>
				<el-descriptions-item label="申报单价">
					<!-- <el-input maxlength='450' v-model="productDetail.customsPrice"></el-input> -->
					<el-input
						placeholder="请输入单价"
						v-model="productDetail.customsProductPrice"
					>
						<template slot="append">{{ productDetail.currencyCode }}</template>
					</el-input>
				</el-descriptions-item>
				<!-- <el-descriptions-item label="申报(日元)价格" v-if="prentType == 'smallBag'">
          <el-input maxlength='450' v-model="productDetail.customsPriceJp"></el-input>
        </el-descriptions-item> -->
				<el-descriptions-item label="报关编码">
					<el-input
						maxlength="450"
						v-model="productDetail.productDeclarationCode"
					></el-input>
				</el-descriptions-item>
				<!-- <el-descriptions-item label="其他" span="2">
          <el-checkbox-group v-model="checkList">
            <el-checkbox v-for="item in checkTypes" :key="item.value" :label="item.value" >{{item.label}}</el-checkbox>
          </el-checkbox-group>
        </el-descriptions-item> -->
			</el-descriptions>
		</el-card>
	</div>
</template>

<script>
import ImgView from "@/components/ImgView";
import {
	modifyCustoms,
	skuInfo,
	goodsFeign,
	goodsFeign_new,
} from "@/apis/outStock";

export default {
	name: "goodsDetails", // 国际发货---商品详情
	components: {
		ImgView,
	},
	props: {
		goodsId: {
			type: String | Number,
		},
	},
	data() {
		return {
			productDetail: {},
			prentType: "",
			tableType: "",
			deliveryTaskDetailId: "",
			productSku: "",
		};
	},
	methods: {
		toModifyCustoms(state) {
			if (
				!checkNum(this.productDetail.customsProductPrice) &&
				this.productDetail.currencyCode === "KRW"
			) {
				return this.$message.error("单价必须为整数");
			}
			function checkNum(num) {
				return Number.isInteger(Number(num)) && num > 0;
			}
			let params = {
				deliveryTaskDetailId: this.productDetail.deliveryTaskDetailId,
				productCategoryEnglishName:
					this.productDetail.productCategoryEnglishName,
				productCategoryName: this.productDetail.productCategoryName,
				productDeclarationCode: this.productDetail.productDeclarationCode,
				customsPrice: this.productDetail.customsPrice,
				customsProductPrice: this.productDetail.customsProductPrice,
				customsPriceJp: this.productDetail.customsPriceJp,
				compilationMethod: this.productDetail.compilationMethod,
				compilationMethodEn: this.productDetail.compilationMethodEn,
				state: state,
			};
			modifyCustoms(params).then(({ code }) => {
				if (code === 0) {
					this.$message.success("成功");
				}
			});
		},
		getskuinfo(id) {
			let params = {
				deliveryTaskDetailId: id,
			};
			skuInfo(params).then(({ code, data }) => {
				if (code === 0) {
					this.productDetail = data;
				}
			});
		},
		getgoodsFeign() {
			goodsFeign_new({
				productSku: this.productSku,
				deliveryTaskDetailId: this.deliveryTaskDetailId,
			}).then(({ code, data }) => {
				if (code === 0) {
					if (data) {
						this.productDetail.productDeclarationCode = data.customsCode;
						this.productDetail.compilationMethod = data.compilationMethod;
						this.productDetail.compilationMethodEn = data.compilationMethodEn;
						this.productDetail.productCategoryName = data.productItemCategoryZh;
						this.productDetail.productCategoryEnglishName =
							data.productItemCategoryEn;
						this.productDetail.customsPriceJp = data.customsPriceJp;
						this.productDetail.customsProductPrice = data.customsProductPrice;
						this.productDetail.customsPrice = data.customsPrice;
						// this.toModifyCustoms(1)
						this.$message.success("更新成功");
						this.getskuinfo(
							this.$route.params.productDetail.deliveryTaskDetailId
						);
					} else {
						this.$message.warning("无报关信息");
					}
				}
			});
		},
	},
	activated() {
		if (this.$route.params.productDetail) {
			this.getskuinfo(this.$route.params.productDetail.deliveryTaskDetailId);
			this.productSku = this.$route.params.productDetail.productSku;
			this.deliveryTaskDetailId =
				this.$route.params.productDetail.deliveryTaskDetailId;
			this.prentType = this.$route.params.prentType;
			this.tableType = this.$route.params.tableType;
		} else {
			// this.$router.replace('/outOfStock_internationalShipment')
		}
	},
};
</script>

<style scoped>
.box-card ::v-deep.el-card__header {
	background: #f8f8f8;
}

.box-card {
	margin-bottom: 20px;
}

.clearfix {
	text-align: left;
	font-size: 14px;
	font-weight: bold;
}
</style>
